export const PRODUCTS_LIST_REQUEST = "PRODUCTS_LIST_REQUEST"
export const PRODUCTS_LIST_SUCCESS = "PRODUCTS_LIST_SUCCESS"
export const PRODUCTS_LIST_FAIL = "PRODUCTS_LIST_FAIL"
export const PRODUCTS_DETAILS_REQUEST = "PRODUCTS_DETAILS_REQUEST"
export const PRODUCTS_DETAILS_SUCCESS = "PRODUCTS_DETAILS_SUCCESS"
export const PRODUCTS_DETAILS_FAIL = "PRODUCTS_DETAILS_FAIL"
export const CART_ADD_ITEMS = "CART_ADD_ITEMS"
export const CART_FAIL_ITEMS = "CART_FAIL_ITEMS"
export const CART_REMOVE_ITEMS = "CART_REMOVE_ITEMS"
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL"
export const USER_LOGOUT = "USER_LOGOUT"
export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST"
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS"
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL"
export const USER_DETAIL_REQUEST = "USER_DETAIL_REQUEST"
export const USER_DETAIL_SUCCESS = "USER_DETAIL_SUCCESS"
export const USER_DETAIL_FAIL = "USER_DETAIL_FAIL"
export const USER_PASSWORD_REQUEST = "USER_PASSWORD_REQUEST"
export const USER_PASSWORD_SUCCESS = "USER_PASSWORD_SUCCESS"
export const USER_PASSWORD_FAIL = "USER_PASSWORD_FAIL"
export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST"
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS"
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL"
export const GOOGLE_LOGIN_REQUEST = "GOOGLE_LOGIN_REQUEST"
export const GOOGLE_LOGIN_SUCCESS = "GOOGLE_LOGIN_SUCCESS"
export const GOOGLE_LOGIN_FAIL = "GOOGLE_LOGIN_FAIL"
export const EMAIL_SEND_REQUEST = "EMAIL_SEND_REQUEST"
export const EMAIL_SEND_SUCCESS = "EMAIL_SEND_SUCCESS"
export const EMAIL_SEND_FAIL = "EMAIL_SEND_FAIL"
export const CODE_VERIFY_REQUEST = "CODE_VERIFY_REQUEST"
export const CODE_VERIFY_SUCCESS = "CODE_VERIFY_SUCCESS"
export const CODE_VERIFY_FAIL = "CODE_VERIFY_FAIL"
export const USER_RESETPASSWORD_REQUEST = "USER_PASSWORD_REQUEST"
export const USER_RESETPASSWORD_SUCCESS = "USER_PASSWORD_SUCCESS"
export const USER_RESETPASSWORD_FAIL = "USER_PASSWORD_FAIL"
export const SHIPPING_ADDRESS = "SHIPPING_ADDRESS"
export const PAYMENT_METHOD = "PAYMENT_METHOD"
export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST"
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS"
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL"
export const ORDER_BY_ID_SUCCESS = "ORDER_BY_ID_SUCCESS"
export const ORDER_BY_ID_FAIL = "ORDER_BY_ID_FAIL"
export const ORDER_BY_ID_REQUEST = "ORDER_BY_ID_REQUEST"
export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST"
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS"
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL"
export const ORDER_PAY_RESET = "ORDER_PAY_RESET"
export const CLIENT_ID = "CLIENT_ID"
export const WISHLIST_ADD_REQUEST = "WISHLIST_ADD_REQUEST"
export const WISHLIST_ADD_SUCCESS = "WISHLIST_ADD_SUCCESS"
export const WISHLIST_ADD_FAIL = "WISHLIST_ADD_FAIL"
export const WISHLIST_REMOVE_REQUEST = "WISHLIST_REMOVE_REQUEST"
export const WISHLIST_REMOVE_SUCCESS = "WISHLIST_REMOVE_SUCCESS"
export const WISHLIST_REMOVE_FAIL = "WISHLIST_REMOVE_FAIL"
export const MYORDERS_LIST_REQUEST = "MYORDERS_LIST_REQUEST"
export const MYORDERS_LIST_SUCCESS = "MYORDERS_LIST_SUCCESS"
export const MYORDERS_LIST_FAIL = "MYORDERS_LIST_FAIL"
export const RETURN_REQUEST = "RETURN_REQUEST"
export const RETURN_SUCCESS = "RETURN_SUCCESS"
export const RETURN_FAIL = "RETURN_FAIL"
export const USERLIST_REQUEST = "USERLIST_REQUEST"
export const USERLIST_SUCCESS = "USERLIST_SUCCESS"
export const USERLIST_FAIL = "USERLIST_FAIL"
export const USERLIST_RESET = "USERLIST_RESET"
export const USERDELETE_REQUEST = "USERDELETE_REQUEST"
export const USERDELETE_SUCCESS = "USERDELETE_SUCCESS"
export const USERDELETE_FAIL = "USERDELETE_FAIL"
export const USERDELETE_RESET = "USERDELETE_RESET"
export const PRODUCT_EDIT_REQUEST = "PRODUCT_EDIT_REQUEST"
export const PRODUCT_EDIT_SUCCESS = "PRODUCT_EDIT_SUCCESS"
export const PRODUCT_EDIT_FAIL = "PRODUCT_EDIT_FAIL"
export const PRODUCT_EDIT_RESET = "PRODUCT_EDIT_RESET"
export const PRODUCT_CREATE_SUCCESS = "PRODUCT_CREATE_SUCCESS"
export const PRODUCT_CREATE_REQUEST = "PRODUCT_CREATE_REQUEST"
export const PRODUCT_CREATE_FAIL = "PRODUCT_CREATE_FAIL"
export const PRODUCT_CREATE_RESET = "PRODUCT_CREATE_RESET"
export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST"
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS"
export const PRODUCT_DELETE_FAIL = "PRODUCT_DELETE_FAIL"
export const PRODUCT_DELETE_RESET = "PRODUCT_DELETE_RESET"
export const ORDERS_LIST_REQUEST = "ORDERS_LIST_REQUEST"
export const ORDERS_LIST_SUCCESS = "ORDERS_LIST_SUCCESS"
export const ORDERS_LIST_FAIL = "ORDERS_LIST_FAIL"
export const ORDERS_LIST_RESET = "ORDERS_LIST_RESET"
export const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST"
export const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS"
export const ORDER_DELIVER_FAIL = "ORDER_DELIVER_FAIL"
export const ORDER_DELIVER_RESET = "ORDER_DELIVER_RESET"
export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST"
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS"
export const CREATE_REVIEW_FAIL = "CREATE_REVIEW_FAIL"
export const CREATE_REVIEW_RESET = "CREATE_REVIEW_RESET"
export const REVIEWS_LIST_REQUEST = "REVIEWS_LIST_REQUEST"
export const REVIEWS_LIST_SUCCESS = "REVIEWS_LIST_SUCCESS"
export const REVIEWS_LIST_FAIL = "REVIEWS_LIST_FAIL"
export const TOP_PRODUCTS_REQUEST = "TOP_PRODUCTS_REQUEST"
export const TOP_PRODUCTS_SUCCESS = "TOP_PRODUCTS_SUCCESS"
export const TOP_PRODUCTS_FAIL = "TOP_PRODUCTS_FAIL"
